const mixin = {
    props: {
        fieldData: Object,
        getter: String,
        setter: String,
    },
}

export default mixin
